import styled from "styled-components";

/* Main section wrapper */
export const Section = styled.section`
  padding: 50px 20px;
  background-color: #0a0a0a;
  text-align: center;
  border-top: 2px solid #0ff;
  border-bottom: 2px solid #0ff;
`;

/* Heading */
export const Heading = styled.h2`
  font-size: 2.5rem;
  color: #0ff;
  margin-bottom: 30px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;
`;

/* Gallery container */
export const Gallery = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding: 20px; /* extra padding so first/last image not cut */
  scroll-behavior: smooth;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #0ff;
    border-radius: 10px;
    box-shadow: 0 0 5px #0ff;
  }
  &::-webkit-scrollbar-track {
    background: #111;
  }
`;

/* Individual Image */
export const Image = styled.img`
  height: 350px;
  min-width: 250px; /* ensures images are fully visible */
  object-fit: cover;
  border-radius: 12px;
  transition: all 0.5s ease;
  cursor: pointer;
  filter: drop-shadow(0 0 5px #0ff);
  transform: perspective(600px) rotateY(0deg);

  &:hover {
    transform: perspective(600px) rotateY(10deg) scale(1.1);
    box-shadow:
      0 0 15px #0ff,
      0 0 30px #0ff,
      0 0 45px #0ff,
      0 0 60px #00ffffaa;
    filter: drop-shadow(0 0 10px #0ff);
    border: 2px solid #0ff;
  }

  @media (max-width: 480px) {
    height: 200px;
    min-width: 150px;
  }
`;
